export interface BaseField {
    fieldName: string;
    isBadge: boolean;
    isSubField: boolean;
}

export interface SimpleField extends BaseField {
    fieldLink: string;
    badgeCount?: number;
    isSubField: false;
}

export interface SubField {
    subFieldName: string;
    subFieldLink: string;
}

export interface DropdownField extends BaseField {
    subFieldList: SubField[];
    isSubField: true;
}

export type SidebarField = SimpleField | DropdownField;

const makeField = (
    fieldName: string,
    fieldLink: string,
    isBadge = false,
): SimpleField => ({
    fieldName,
    fieldLink,
    isBadge,
    isSubField: false,
});

const allSmiles = makeField("All Smiles", "/dashboard/smiledesign/all-smiles");
const listCreditPackages = makeField("Credit Packages", "/dashboard/smiledesign/list-credits");
const myOrders = makeField("Order History", "/dashboard/smiledesign/my-orders");
const manualCredits = makeField("Manual Credits", "/dashboard/smiledesign/manual-credits");
const creditAuditLogs = makeField("Credit Audit Logs", "/dashboard/smiledesign/credit-audit-logs");
const creditUsageHistory = makeField("Credit Usage", "/dashboard/smiledesign/credit-usage");
const mySmiles = makeField("My Smiles", "/dashboard/smiledesign/my-smiles");
const packageManager = makeField("Package Manager", "/dashboard/smiledesign/package-manager");
const paymentManager = makeField("Payment Manager", "/dashboard/smiledesign/payment-manager");
const promptManager = makeField("Prompts & Filters", "/dashboard/smiledesign/prompt-manager");
const refundManager = makeField("Refund Manager", "/dashboard/smiledesign/refund-manager");
const clientManagement = makeField("Client Management", "/dashboard/smiledesign/client-management");
const smileGeneration = makeField("Smile Generation", "/dashboard/smiledesign/generate");
const profile = makeField("Profile", "/dashboard/smiledesign/profile");



export const superAdminFields: SidebarField[] = [
    profile,
    smileGeneration,
    promptManager,
    allSmiles,
    mySmiles,
    clientManagement,
    listCreditPackages,
    manualCredits,
    creditAuditLogs,
    creditUsageHistory,
    packageManager,
    paymentManager,
    refundManager,
];


export const adminReadFields: SidebarField[] = [
    profile,
    smileGeneration,
    promptManager,
    allSmiles,
    mySmiles,
    listCreditPackages,
    manualCredits,
    creditAuditLogs,
    creditUsageHistory,
    packageManager,
    paymentManager,
    refundManager,
];


export const sideAdminFields: SidebarField[] = [
    profile,
    smileGeneration,
    mySmiles,
    listCreditPackages,
    myOrders,
];


export const userFields: SidebarField[] = [
    profile,
    smileGeneration,
    mySmiles,
    listCreditPackages,
    myOrders,
];
